// List of 80 most populated countries sorted by country name with
// 10 top Dokka org countries by usage at the top
export const COUNTRY_CODES = [
  { country: 'Israel', countryHe: 'ישראל', code: '+972', locale: 'IL' },
  { country: 'South Africa', countryHe: 'דרום אפריקה', code: '+27', locale: 'ZA' },
  { country: 'United States', countryHe: 'ארצות הברית', code: '+1', locale: 'US' },
  { country: 'United Kingdom', countryHe: 'בריטניה', code: '+44', locale: 'GB' },
  { country: 'Cayman Islands', countryHe: 'איי קיימן', code: '+1-345', locale: 'KY' },
  { country: 'Australia', countryHe: 'אוסטרליה', code: '+61', locale: 'AU' },
  { country: 'Canada', countryHe: 'קנדה', code: '+1', locale: 'CA' },
  { country: 'Cyprus', countryHe: 'קפריסין', code: '+357', locale: 'CY' },
  { country: 'Ukraine', countryHe: 'אוקראינה', code: '+380', locale: 'UA' },
  { country: 'Ecuador', countryHe: 'אקוודור', code: '+593', locale: 'EC' },
  { country: 'Afghanistan', countryHe: 'אפגניסטן', code: '+93', locale: 'AF' },
  { country: 'Aland Islands', countryHe: 'איי אולנד', code: '+358', locale: 'AX' },
  { country: 'Albania', countryHe: 'אלבניה', code: '+355', locale: 'AL' },
  { country: 'Algeria', countryHe: "אלג'יריה", code: '+213', locale: 'DZ' },
  { country: 'American Samoa', countryHe: 'סמואה האמריקנית', code: '+1684', locale: 'AS' },
  { country: 'Andorra', countryHe: 'אנדורה', code: '+376', locale: 'AD' },
  { country: 'Angola', countryHe: 'אנגולה', code: '+244', locale: 'AO' },
  { country: 'Anguilla', countryHe: 'אנגווילה', code: '+1264', locale: 'AI' },
  { country: 'Antigua and Barbuda', countryHe: 'אנטיגואה וברבודה', code: '+1268', locale: 'AG' },
  { country: 'Argentina', countryHe: 'ארגנטינה', code: '+54', locale: 'AR' },
  { country: 'Armenia', countryHe: 'ארמניה', code: '+374', locale: 'AM' },
  { country: 'Aruba', countryHe: 'ארובה', code: '+297', locale: 'AW' },
  { country: 'Austria', countryHe: 'אוסטריה', code: '+43', locale: 'AT' },
  { country: 'Azerbaijan', countryHe: "אזרבייג'ן", code: '+994', locale: 'AZ' },
  { country: 'Bahamas', countryHe: 'איי בהאמה', code: '+1242', locale: 'BS' },
  { country: 'Bahrain', countryHe: 'בחריין', code: '+973', locale: 'BH' },
  { country: 'Bangladesh', countryHe: 'בנגלדש', code: '+880', locale: 'BD' },
  { country: 'Barbados', countryHe: 'ברבדוס', code: '+1246', locale: 'BB' },
  { country: 'Belarus', countryHe: 'בלארוס', code: '+375', locale: 'BY' },
  { country: 'Belgium', countryHe: 'בלגיה', code: '+32', locale: 'BE' },
  { country: 'Belize', countryHe: 'בליז', code: '+501', locale: 'BZ' },
  { country: 'Benin', countryHe: 'בנין', code: '+229', locale: 'BJ' },
  { country: 'Bermuda', countryHe: 'ברמודה', code: '+1441', locale: 'BM' },
  { country: 'Bhutan', countryHe: 'בהוטן', code: '+975', locale: 'BT' },
  { country: 'Bolivia', countryHe: 'בוליביה', code: '+591', locale: 'BO' },
  { country: 'Bosnia and Herzegovina', countryHe: 'בוסניה והרצגובינה', code: '+387', locale: 'BA' },
  { country: 'Botswana', countryHe: 'בוצוונה', code: '+267', locale: 'BW' },
  { country: 'Brazil', countryHe: 'ברזיל', code: '+55', locale: 'BR' },
  {
    country: 'British Indian Ocean Territory',
    countryHe: 'טריטוריה בריטית באוקיינוס ההודי',
    code: '+246',
    locale: 'IO',
  },
  { country: 'British Virgin Islands', countryHe: 'איי הבתולה הבריטיים', code: '+1284', locale: 'VG' },
  { country: 'Brunei', countryHe: 'ברוניי', code: '+673', locale: 'BN' },
  { country: 'Bulgaria', countryHe: 'בולגריה', code: '+359', locale: 'BG' },
  { country: 'Burkina Faso', countryHe: 'בורקינה פאסו', code: '+226', locale: 'BF' },
  { country: 'Burundi', countryHe: 'בורונדי', code: '+257', locale: 'BI' },
  { country: 'Cambodia', countryHe: 'קמבודיה', code: '+855', locale: 'KH' },
  { country: 'Cameroon', countryHe: 'קמרון', code: '+237', locale: 'CM' },
  { country: 'Cape Verde', countryHe: 'כף ורדה', code: '+238', locale: 'CV' },
  { country: 'Central African Republic', countryHe: 'הרפובליקה המרכז אפריקאית', code: '+236', locale: 'CF' },
  { country: 'Chad', countryHe: "צ'אד", code: '+235', locale: 'TD' },
  { country: 'Chile', countryHe: "צ'ילה", code: '+56', locale: 'CL' },
  { country: 'China', countryHe: 'סין', code: '+86', locale: 'CN' },
  { country: 'Christmas Island', countryHe: 'אי חג המולד', code: '+61', locale: 'CX' },
  { country: 'Cocos (Keeling) Islands', countryHe: 'איי קוקוס', code: '+61', locale: 'CC' },
  { country: 'Colombia', countryHe: 'קולומביה', code: '+57', locale: 'CO' },
  { country: 'Comoros', countryHe: 'קומורו', code: '+269', locale: 'KM' },
  { country: 'Congo (DRC)', countryHe: 'קונגו', code: '+243', locale: 'CD' },
  { country: 'Cook Islands', countryHe: 'איי קוק', code: '+682', locale: 'CK' },
  { country: 'Costa Rica', countryHe: 'קוסטה ריקה', code: '+506', locale: 'CR' },
  { country: 'Croatia', countryHe: 'קרואטיה', code: '+385', locale: 'HR' },
  { country: 'Cuba', countryHe: 'קובה', code: '+53', locale: 'CU' },
  { country: 'Curacao', countryHe: 'קוראסאו', code: '+5999', locale: 'CW' },
  { country: 'Czech Republic', countryHe: "צ'כיה", code: '+420', locale: 'CZ' },
  { country: 'Denmark', countryHe: 'דנמרק', code: '+45', locale: 'DK' },
  { country: 'Djibouti', countryHe: "ג'יבוטי", code: '+253', locale: 'DJ' },
  { country: 'Dominica', countryHe: 'דומיניקה', code: '+1767', locale: 'DM' },
  { country: 'Dominican Republic', countryHe: 'הרפובליקה הדומיניקנית', code: '+1-809', locale: 'DO' },
  { country: 'Egypt', countryHe: 'מצרים', code: '+20', locale: 'EG' },
  { country: 'El Salvador', countryHe: 'אל סלבדור', code: '+503', locale: 'SV' },
  { country: 'Equatorial Guinea', countryHe: 'גינאה המשוונית', code: '+240', locale: 'GQ' },
  { country: 'Eritrea', countryHe: 'אריתריאה', code: '+291', locale: 'ER' },
  { country: 'Estonia', countryHe: 'אסטוניה', code: '+372', locale: 'EE' },
  { country: 'Ethiopia', countryHe: 'אתיופיה', code: '+251', locale: 'ET' },
  { country: 'Falkland Islands', countryHe: 'איי פוקלנד', code: '+500', locale: 'FK' },
  { country: 'Faroe Islands', countryHe: 'איי פארו', code: '+298', locale: 'FO' },
  { country: 'Fiji', countryHe: "פיג'י", code: '+679', locale: 'FJ' },
  { country: 'Finland', countryHe: 'פינלנד', code: '+358', locale: 'FI' },
  { country: 'France', countryHe: 'צרפת', code: '+33', locale: 'FR' },
  { country: 'French Guiana', countryHe: 'גיאנה הצרפתית', code: '+594', locale: 'GF' },
  { country: 'French Polynesia', countryHe: 'פולינזיה הצרפתית', code: '+689', locale: 'PF' },
  { country: 'Gabon', countryHe: 'גבון', code: '+241', locale: 'GA' },
  { country: 'Gambia', countryHe: 'גמביה', code: '+220', locale: 'GM' },
  { country: 'Georgia', countryHe: 'גאורגיה', code: '+995', locale: 'GE' },
  { country: 'Germany', countryHe: 'גרמניה', code: '+49', locale: 'DE' },
  { country: 'Ghana', countryHe: 'גאנה', code: '+233', locale: 'GH' },
  { country: 'Gibraltar', countryHe: 'גיברלטר', code: '+350', locale: 'GI' },
  { country: 'Greece', countryHe: 'יוון', code: '+30', locale: 'GR' },
  { country: 'Greenland', countryHe: 'גרינלנד', code: '+299', locale: 'GL' },
  { country: 'Grenada', countryHe: 'גרנדה', code: '+1473', locale: 'GD' },
  { country: 'Guadeloupe', countryHe: 'גוואדלופ', code: '+590', locale: 'GP' },
  { country: 'Guam', countryHe: 'גואם', code: '+1671', locale: 'GU' },
  { country: 'Guatemala', countryHe: 'גואטמלה', code: '+502', locale: 'GT' },
  { country: 'Guernsey', countryHe: 'גרנזי', code: '+44', locale: 'GG' },
  { country: 'Guinea', countryHe: 'גינאה', code: '+224', locale: 'GN' },
  { country: 'Guinea-Bissau', countryHe: 'גינאה ביסאו', code: '+245', locale: 'GW' },
  { country: 'Guyana', countryHe: 'גיאנה', code: '+592', locale: 'GY' },
  { country: 'Haiti', countryHe: 'האיטי', code: '+509', locale: 'HT' },
  { country: 'Honduras', countryHe: 'הונדורס', code: '+504', locale: 'HN' },
  { country: 'Hong Kong', countryHe: 'הונג קונג', code: '+852', locale: 'HK' },
  { country: 'Hungary', countryHe: 'הונגריה', code: '+36', locale: 'HU' },
  { country: 'Iceland', countryHe: 'איסלנד', code: '+354', locale: 'IS' },
  { country: 'India', countryHe: 'הודו', code: '+91', locale: 'IN' },
  { country: 'Indonesia', countryHe: 'אינדונזיה', code: '+62', locale: 'ID' },
  { country: 'Iran', countryHe: 'איראן', code: '+98', locale: 'IR' },
  { country: 'Iraq', countryHe: 'עיראק', code: '+964', locale: 'IQ' },
  { country: 'Ireland', countryHe: 'אירלנד', code: '+353', locale: 'IE' },
  { country: 'Isle of Man', countryHe: 'האי מאן', code: '+44', locale: 'IM' },
  { country: 'Italy', countryHe: 'איטליה', code: '+39', locale: 'IT' },
  { country: 'Ivory Coast', countryHe: 'חוף השנהב', code: '+225', locale: 'CI' },
  { country: 'Jamaica', countryHe: "ג'מייקה", code: '+1876', locale: 'JM' },
  { country: 'Japan', countryHe: 'יפן', code: '+81', locale: 'JP' },
  { country: 'Jersey', countryHe: "ג'רזי", code: '+44', locale: 'JE' },
  { country: 'Jordan', countryHe: 'ירדן', code: '+962', locale: 'JO' },
  { country: 'Kazakhstan', countryHe: 'קזחסטן', code: '+7', locale: 'KZ' },
  { country: 'Kenya', countryHe: 'קניה', code: '+254', locale: 'KE' },
  { country: 'Kiribati', countryHe: 'קיריבטי', code: '+686', locale: 'KI' },
  { country: 'Kosovo', countryHe: 'קוסובו', code: '+383', locale: 'XK' },
  { country: 'Kuwait', countryHe: 'כווית', code: '+965', locale: 'KW' },
  { country: 'Kyrgyzstan', countryHe: 'קירגיזסטן', code: '+996', locale: 'KG' },
  { country: 'Laos', countryHe: 'לאוס', code: '+856', locale: 'LA' },
  { country: 'Latvia', countryHe: 'לטביה', code: '+371', locale: 'LV' },
  { country: 'Lebanon', countryHe: 'לבנון', code: '+961', locale: 'LB' },
  { country: 'Lesotho', countryHe: 'לסוטו', code: '+266', locale: 'LS' },
  { country: 'Liberia', countryHe: 'ליבריה', code: '+231', locale: 'LR' },
  { country: 'Libya', countryHe: 'לוב', code: '+218', locale: 'LY' },
  { country: 'Liechtenstein', countryHe: 'ליכטנשטיין', code: '+423', locale: 'LI' },
  { country: 'Lithuania', countryHe: 'ליטא', code: '+370', locale: 'LT' },
  { country: 'Luxembourg', countryHe: 'לוקסמבורג', code: '+352', locale: 'LU' },
  { country: 'Macau', countryHe: 'מקאו', code: '+853', locale: 'MO' },
  { country: 'Macedonia', countryHe: 'מקדוניה', code: '+389', locale: 'MK' },
  { country: 'Madagascar', countryHe: 'מדגסקר', code: '+261', locale: 'MG' },
  { country: 'Malawi', countryHe: 'מלאווי', code: '+265', locale: 'MW' },
  { country: 'Malaysia', countryHe: 'מלזיה', code: '+60', locale: 'MY' },
  { country: 'Maldives', countryHe: 'האיים המלדיביים', code: '+960', locale: 'MV' },
  { country: 'Mali', countryHe: 'מאלי', code: '+223', locale: 'ML' },
  { country: 'Malta', countryHe: 'מלטה', code: '+356', locale: 'MT' },
  { country: 'Marshall Islands', countryHe: 'איי מרשל', code: '+692', locale: 'MH' },
  { country: 'Martinique', countryHe: 'מרטיניק', code: '+596', locale: 'MQ' },
  { country: 'Mauritania', countryHe: 'מאוריטניה', code: '+222', locale: 'MR' },
  { country: 'Mauritius', countryHe: 'מאוריציוס', code: '+230', locale: 'MU' },
  { country: 'Mayotte', countryHe: 'מאיוט', code: '+262', locale: 'YT' },
  { country: 'Mexico', countryHe: 'מקסיקו', code: '+52', locale: 'MX' },
  { country: 'Micronesia', countryHe: 'מיקרונזיה', code: '+691', locale: 'FM' },
  { country: 'Moldova', countryHe: 'מולדובה', code: '+373', locale: 'MD' },
  { country: 'Monaco', countryHe: 'מונקו', code: '+377', locale: 'MC' },
  { country: 'Mongolia', countryHe: 'מונגוליה', code: '+976', locale: 'MN' },
  { country: 'Montenegro', countryHe: 'מונטנגרו', code: '+382', locale: 'ME' },
  { country: 'Montserrat', countryHe: 'מונטסראט', code: '+1664', locale: 'MS' },
  { country: 'Morocco', countryHe: 'מרוקו', code: '+212', locale: 'MA' },
  { country: 'Mozambique', countryHe: 'מוזמביק', code: '+258', locale: 'MZ' },
  { country: 'Myanmar', countryHe: 'מיאנמר', code: '+95', locale: 'MM' },
  { country: 'Namibia', countryHe: 'נמיביה', code: '+264', locale: 'NA' },
  { country: 'Nauru', countryHe: 'נאורו', code: '+674', locale: 'NR' },
  { country: 'Nepal', countryHe: 'נפאל', code: '+977', locale: 'NP' },
  { country: 'Netherlands', countryHe: 'הולנד', code: '+31', locale: 'NL' },
  { country: 'New Caledonia', countryHe: 'קלדוניה החדשה', code: '+687', locale: 'NC' },
  { country: 'New Zealand', countryHe: 'ניו זילנד', code: '+64', locale: 'NZ' },
  { country: 'Nicaragua', countryHe: 'ניקרגואה', code: '+505', locale: 'NI' },
  { country: 'Niger', countryHe: "ניז'ר", code: '+227', locale: 'NE' },
  { country: 'Nigeria', countryHe: 'ניגריה', code: '+234', locale: 'NG' },
  { country: 'Niue', countryHe: 'ניווה', code: '+683', locale: 'NU' },
  { country: 'Norfolk Island', countryHe: 'אי נורפוק', code: '+672', locale: 'NF' },
  { country: 'North Korea', countryHe: 'צפון קוריאה', code: '+850', locale: 'KP' },
  { country: 'Northern Mariana Islands', countryHe: 'איי מריאנה הצפוניים', code: '+1670', locale: 'MP' },
  { country: 'Norway', countryHe: 'נורווגיה', code: '+47', locale: 'NO' },
  { country: 'Oman', countryHe: 'עומאן', code: '+968', locale: 'OM' },
  { country: 'Pakistan', countryHe: 'פקיסטן', code: '+92', locale: 'PK' },
  { country: 'Palau', countryHe: 'פלאו', code: '+680', locale: 'PW' },
  { country: 'Palestine', countryHe: 'פלסטין', code: '+970', locale: 'PS' },
  { country: 'Panama', countryHe: 'פנמה', code: '+507', locale: 'PA' },
  { country: 'Papua New Guinea', countryHe: 'פפואה גינאה החדשה', code: '+675', locale: 'PG' },
  { country: 'Paraguay', countryHe: 'פרגוואי', code: '+595', locale: 'PY' },
  { country: 'Peru', countryHe: 'פרו', code: '+51', locale: 'PE' },
  { country: 'Philippines', countryHe: 'הפיליפינים', code: '+63', locale: 'PH' },
  { country: 'Pitcairn Islands', countryHe: 'איי פיטקרן', code: '+64', locale: 'PN' },
  { country: 'Poland', countryHe: 'פולין', code: '+48', locale: 'PL' },
  { country: 'Portugal', countryHe: 'פורטוגל', code: '+351', locale: 'PT' },
  { country: 'Puerto Rico', countryHe: 'פוארטו ריקו', code: '+1787', locale: 'PR' },
  { country: 'Qatar', countryHe: 'קטאר', code: '+974', locale: 'QA' },
  { country: 'Republic of the Congo', countryHe: 'הרפובליקה של קונגו', code: '+242', locale: 'CG' },
  { country: 'Reunion', countryHe: 'ראוניון', code: '+262', locale: 'RE' },
  { country: 'Romania', countryHe: 'רומניה', code: '+40', locale: 'RO' },
  { country: 'Russia', countryHe: 'רוסיה', code: '+7', locale: 'RU' },
  { country: 'Rwanda', countryHe: 'רואנדה', code: '+250', locale: 'RW' },
  { country: 'Saint Barthelemy', countryHe: 'סנט ברתלמי', code: '+590', locale: 'BL' },
  { country: 'Saint Kitts and Nevis', countryHe: 'סנט קיטס ונוויס', code: '+1869', locale: 'KN' },
  { country: 'Saint Lucia', countryHe: 'סנט לוסיה', code: '+1758', locale: 'LC' },
  { country: 'Saint Martin', countryHe: 'סנט מרטין', code: '+590', locale: 'MF' },
  { country: 'Saint Pierre and Miquelon', countryHe: 'סנט פייר ומיקלון', code: '+508', locale: 'PM' },
  { country: 'Saint Vincent and the Grenadines', countryHe: 'סנט וינסנט והגרנדינים', code: '+1784', locale: 'VC' },
  { country: 'Samoa', countryHe: 'סמואה', code: '+685', locale: 'WS' },
  { country: 'San Marino', countryHe: 'סן מרינו', code: '+378', locale: 'SM' },
  { country: 'Sao Tome and Principe', countryHe: 'סאו טומה ופרינסיפה', code: '+239', locale: 'ST' },
  { country: 'Saudi Arabia', countryHe: 'ערב הסעודית', code: '+966', locale: 'SA' },
  { country: 'Senegal', countryHe: 'סנגל', code: '+221', locale: 'SN' },
  { country: 'Serbia', countryHe: 'סרביה', code: '+381', locale: 'RS' },
  { country: 'Seychelles', countryHe: 'איי סיישל', code: '+248', locale: 'SC' },
  { country: 'Sierra Leone', countryHe: 'סיירה לאון', code: '+232', locale: 'SL' },
  { country: 'Singapore', countryHe: 'סינגפור', code: '+65', locale: 'SG' },
  { country: 'Sint Maarten', countryHe: 'סינט מארטן', code: '+1721', locale: 'SX' },
  { country: 'Slovakia', countryHe: 'סלובקיה', code: '+421', locale: 'SK' },
  { country: 'Slovenia', countryHe: 'סלובניה', code: '+386', locale: 'SI' },
  { country: 'Solomon Islands', countryHe: 'איי שלמה', code: '+677', locale: 'SB' },
  { country: 'Somalia', countryHe: 'סומליה', code: '+252', locale: 'SO' },
  { country: 'South Georgia', countryHe: "דרום ג'ורג'יה", code: '+500', locale: 'GS' },
  { country: 'South Korea', countryHe: 'דרום קוריאה', code: '+82', locale: 'KR' },
  { country: 'South Sudan', countryHe: 'דרום סודן', code: '+211', locale: 'SS' },
  { country: 'Spain', countryHe: 'ספרד', code: '+34', locale: 'ES' },
  { country: 'Sri Lanka', countryHe: 'סרי לנקה', code: '+94', locale: 'LK' },
  { country: 'Sudan', countryHe: 'סודן', code: '+249', locale: 'SD' },
  { country: 'Suriname', countryHe: 'סורינאם', code: '+597', locale: 'SR' },
  { country: 'Svalbard and Jan Mayen', countryHe: 'סבאלברד ויאן מאיין', code: '+4779', locale: 'SJ' },
  { country: 'Swaziland', countryHe: 'סווזילנד', code: '+268', locale: 'SZ' },
  { country: 'Sweden', countryHe: 'שוודיה', code: '+46', locale: 'SE' },
  { country: 'Switzerland', countryHe: 'שווייץ', code: '+41', locale: 'CH' },
  { country: 'Syria', countryHe: 'סוריה', code: '+963', locale: 'SY' },
  { country: 'Taiwan', countryHe: 'טייוואן', code: '+886', locale: 'TW' },
  { country: 'Tajikistan', countryHe: "טג'יקיסטן", code: '+992', locale: 'TJ' },
  { country: 'Tanzania', countryHe: 'טנזניה', code: '+255', locale: 'TZ' },
  { country: 'Thailand', countryHe: 'תאילנד', code: '+66', locale: 'TH' },
  { country: 'Timor-Leste', countryHe: 'מזרח טימור', code: '+670', locale: 'TL' },
  { country: 'Togo', countryHe: 'טוגו', code: '+228', locale: 'TG' },
  { country: 'Tokelau', countryHe: 'טוקלאו', code: '+690', locale: 'TK' },
  { country: 'Tonga', countryHe: 'טונגה', code: '+676', locale: 'TO' },
  { country: 'Trinidad and Tobago', countryHe: 'טרינידד וטובגו', code: '+1868', locale: 'TT' },
  { country: 'Tunisia', countryHe: 'תוניסיה', code: '+216', locale: 'TN' },
  { country: 'Turkey', countryHe: 'טורקיה', code: '+90', locale: 'TR' },
  { country: 'Turkmenistan', countryHe: 'טורקמניסטן', code: '+993', locale: 'TM' },
  { country: 'Turks and Caicos Islands', countryHe: 'איי טרקס וקייקוס', code: '+1649', locale: 'TC' },
  { country: 'Tuvalu', countryHe: 'טובאלו', code: '+688', locale: 'TV' },
  { country: 'Uganda', countryHe: 'אוגנדה', code: '+256', locale: 'UG' },
  { country: 'United Arab Emirates', countryHe: 'איחוד האמירויות', code: '+971', locale: 'AE' },
  { country: 'United States Virgin Islands', countryHe: 'איי הבתולה האמריקאיים', code: '+1340', locale: 'VI' },
  { country: 'Uruguay', countryHe: 'אורוגוואי', code: '+598', locale: 'UY' },
  { country: 'Uzbekistan', countryHe: 'אוזבקיסטן', code: '+998', locale: 'UZ' },
  { country: 'Vanuatu', countryHe: 'ונואטו', code: '+678', locale: 'VU' },
  { country: 'Vatican City', countryHe: 'קריית הותיקן', code: '+3906698', locale: 'VA' },
  { country: 'Venezuela', countryHe: 'ונצואלה', code: '+58', locale: 'VE' },
  { country: 'Vietnam', countryHe: 'וייטנאם', code: '+84', locale: 'VN' },
  { country: 'Wallis and Futuna', countryHe: 'וואליס ופוטונה', code: '+681', locale: 'WF' },
  { country: 'Western Sahara', countryHe: 'סהרה המערבית', code: '+212', locale: 'EH' },
  { country: 'Yemen', countryHe: 'תימן', code: '+967', locale: 'YE' },
  { country: 'Zambia', countryHe: 'זמביה', code: '+260', locale: 'ZM' },
  { country: 'Zimbabwe', countryHe: 'זימבבואה', code: '+263', locale: 'ZW' },
];

// Shared template for formatting dial codes
// Use LRI (Left-to-Right Isolate \u2066) and PDI (Pop Directional Isolate \u2069)
// to isolate the dial code and keep it LTR even in RTL context
const formatDialCodeDisplay = (country, code) => `${country} \u2066(${code})\u2069`;

// Helper function to format country codes for dialCodeList
export const getFormattedCountryCodes = (rtl = false) => {
  return COUNTRY_CODES.map(({ country, countryHe, code }) => formatDialCodeDisplay(rtl ? countryHe : country, code));
};

// Helper function to extract dial code from formatted string
// Handles Unicode directional characters (LRI \u2066, PDI \u2069)
export const extractDialCode = (formattedDialCode) => {
  // Remove Unicode directional formatting characters
  const cleaned = formattedDialCode.replace(/[\u2066\u2067\u2068\u2069]/g, '');
  const match = cleaned.match(/\((\+[\d-]+)\)$/);
  return match ? match[1] : formattedDialCode;
};

// Get formatted dial code for user's locale (e.g., 'Ukraine (+380)' or 'אוקראינה (+380)')
export const getFormattedDialCodeByUserLocale = (rtl = false, geoIpCountryCode) => {
  // Return empty string if geoIpCountryCode is empty
  if (!geoIpCountryCode) {
    return '';
  }

  const country = COUNTRY_CODES.find((item) => item.locale === geoIpCountryCode);
  if (country) {
    return formatDialCodeDisplay(rtl ? country.countryHe : country.country, country.code);
  }

  // Return empty string if the provided locale is not found
  return '';
};
